import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

// Mirrors the sidebar's menuItems order (components/layout/Sidebar.js).
const SUB_PAGE_ORDER = [
  { key: "dashboard", path: "/ai-command-center/dashboard" },
  { key: "aiOperations", path: "/ai-command-center/ai-operations" },
  { key: "threatZones", path: "/ai-command-center/threat-zones" },
  { key: "forecasting", path: "/ai-command-center/forecasting" },
  { key: "governance", path: "/ai-command-center/governance" },
  { key: "missionControl", path: "/ai-command-center/mission-control" },
  { key: "telemetry", path: "/ai-command-center/telemetry" },
  { key: "incidentArchive", path: "/ai-command-center/incident-archive" },
  { key: "researchValidation", path: "/ai-command-center/research-validation" },
];

const linkStyle = {
  color: "#38bdf8",
  textDecoration: "none",
  fontWeight: 600,
  fontSize: "0.9rem",
  padding: "10px 16px",
  border: "1px solid #1e293b",
  borderRadius: "8px",
  background: "#111827",
};

export default function SubPageNav({ current }) {
  const { t } = useTranslation();
  const index = SUB_PAGE_ORDER.findIndex((p) => p.key === current);
  if (index === -1) return null;

  const prev = index > 0 ? SUB_PAGE_ORDER[index - 1] : null;
  const next = index < SUB_PAGE_ORDER.length - 1 ? SUB_PAGE_ORDER[index + 1] : null;

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        marginTop: "30px",
        paddingTop: "20px",
        borderTop: "1px solid #1e293b",
      }}
    >
      <div>
        {prev && (
          <Link to={prev.path} style={linkStyle}>
            ← {t(`nav.${prev.key}`)}
          </Link>
        )}
      </div>
      <div>
        {next && (
          <Link to={next.path} style={linkStyle}>
            {t(`nav.${next.key}`)} →
          </Link>
        )}
      </div>
    </div>
  );
}
